import React from "react";
import { Helmet } from "react-helmet";
import { connect } from "react-redux";
import { selectors as brandSelectors } from "../../redux/brand";
import setTitle from "../../utils/set-title";

const PageTitle = ({ title, noBrand, brand }) => {
  if (title && !noBrand) {
    return (
      <Helmet>
        <title>{setTitle(brand, title)}</title>
      </Helmet>
    );
  }

  return (
    <Helmet>
      <title>{setTitle(brand)}</title>
    </Helmet>
  );
};

const mapStateToProps = state => ({
  brand: brandSelectors.getBrand(state)
});

export default connect(mapStateToProps)(PageTitle);
